import React from "react";
import * as agent from "../agent";
import PrintLink from "./PrintLink";

export default ({ id, sum, manager }) => {
    return (
        <React.Fragment>
            <PrintLink
                href={agent.src.print("ticket", id)}
                label="ЗБ (Выдача)"
            />
            <PrintLink
                href={agent.src.print("admit_collecting", id)}
                label="Данные"
            />
            <PrintLink
                href={agent.src.print("admit_processing", id)}
                label="Обработка данных"
            />
            <PrintLink
                href={agent.src.print("form", id)}
                label="Анкета Клиента"
            />
            <PrintLink href={agent.src.print("claim", id)} label="Заявление" />
            <PrintLink
                href={agent.src.print("order", id)}
                label="Расходный ордер"
            />
            <PrintLink
                href={agent.src.printLT("lt_order", id, sum, manager)}
                label="Приходный ордер"
            />
            <PrintLink
                href={agent.src.print("lt_transfer", id)}
                label="Акт приема-передачи"
            />
        </React.Fragment>
    );
};



// WEBPACK FOOTER //
// ./src/components/PrintLTLinks.js